import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { CustomValidators } from 'src/app/shared/helpers/custom-validators';

@Component({
  selector: 'hbo-control-messages',
  templateUrl: './control-messages.component.html',
  styleUrls: ['./control-messages.component.scss']
})
export class ControlMessagesComponent {

  @Input() control!: AbstractControl<number | string | boolean | null>;
  @Input() component?: string;

  get errorMessage() {
    for (const propertyName in this.control.errors) {
      if (Object.prototype.hasOwnProperty.call(this.control.errors, propertyName) && this.control.invalid && (this.control.dirty || this.control.touched)) {
        let finalErrorMessage = CustomValidators.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
        switch (this.component) {
          case 'package-actions':
            switch (finalErrorMessage.message) {
              case 'MAX':
                finalErrorMessage.message = 'MAXPACKAGES';
                break;
              default:
                break;
            }
            break;
          case 'team-actions':
            switch (finalErrorMessage.message) {
              case 'INVALID_USERNAME_FORMAT':
                finalErrorMessage.message = 'INVALID_USERNAME_FORMAT';
                break;
              default:
                break;
            }
            break;
          case 'horizonsTeam-actions':
            switch (finalErrorMessage.message) {
              case 'INVALID_USERNAME_FORMAT':
                finalErrorMessage.message = 'INVALID_USERNAME_FORMAT';
                break;
              default:
                break;
            }
            break;
          default:
            break;
        }

        return finalErrorMessage;
      }
    }

    return null;
  }

}
